import type { JiraPostIncidentReviewLink } from '../../types';

export const isJiraPostIncidentReviewLink = (entity: any): entity is JiraPostIncidentReviewLink =>
	entity.__typename === 'JiraPostIncidentReviewLink';

export const getJiraPostIncidentReviewLink = (link: JiraPostIncidentReviewLink): string | null =>
	link?.url ?? null;
